import type React from 'react';

import { Alert } from '@change/ds-core-ui/Alert';

import { SimpleHtml } from '#src/app/shared/components/html';

import { useLoginOrSignupBanner } from './hooks/useLoginOrSignupBanner';

export const LoginOrSignupBanner: React.FC<EmptyProps> = () => {
	const {
		data: { messageHtml },
	} = useLoginOrSignupBanner();

	if (!messageHtml) return null;

	return (
		<Alert type="page" variant="error" data-qa="login-or-signup-error-banner" data-testid="flash-error">
			<SimpleHtml html={messageHtml} />
		</Alert>
	);
};
